export default __webpack_public_path__ + "locales/ro/Common.json?hash=6a036224bd63160e84ec924a779c7591";